<template lang="pug">
  div
    top-nav(headerColor="white")
    .placeholder(v-if="loading")
    transition(name="fade")
      .content.year.month(v-if='!loading')
        .grid
          .col-3_xs-12
            .titles
              h2.h-l
                | learn
              h1.h-xl.category
                | 600state
              h3.h-sm.desc
                | 600state is the blog of the California African American Museum.
              h3.h-sm.date
                | {{ month }} {{ year }}
              h3.h-sm(@click="prev")
                | previous month
              h3.h-sm(@click="next" v-if="!maxReached")
                | next month
          .col-9_xs-12
            .grid.no-margin
              .col-6_xs-12(v-for="post in posts")
                router-link(:to="{name: 'article', params: {article: post.uid }}")
                  .screen-small
                    img.cover(v-if="hero(post)" :src="heroImage(post)" :alt="heroCaption(post)")
                    .captions
                      h2.h-l.lh-95.title.italic
                        | {{ post.content.title }}
                      h2.h-md.author(v-if="post.content.author.length > 0")
                        | {{ post.content.author }} </br>
                        | {{ post.content.date }}
                      h2.h-md.author(v-else)
                        | {{ post.content.date }}
    bottom-nav(footerColor="white")
</template>

<script>
import DataMixin from '@/mixins/DataMixin'
import ComponentMixin from '@/mixins/ComponentMixin'
import dateFormat from 'dateformat'

export default {
  name: 'blog',
  mixins: [DataMixin, ComponentMixin],

  data () {
    return {
      loading: false,
      loadedData: [],
      // url: 'http://localhost:8888/caam/caam_live/api/blog/',
      url: 'https://caamuseum.org/api/blog/',
      offset: 0,
      limit: 15,
      date: new Date(),
      month: dateFormat(this.date, 'mmmm'),
      year: dateFormat(this.date, 'yyyy'),
      months: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
      ],
      index: '',
      maxMonth: dateFormat(this.date, 'mmmm'),
      maxYear: dateFormat(this.date, 'yyyy')
    }
  },

  created () {
    // const loc = window.location
    // const rootUrl = loc.protocol + '//' + loc.host
    // this.url = rootUrl + '/api/blog/'
    this.index = this.months.indexOf(this.month)
    this.getData()
  },

  methods: {
    getData: function () {
      const time = '?year=' + this.year + '&month=' + this.month
      const pag = '&offset=' + this.offset + '&limit=' + this.limit
      const url = this.url + time + pag
      this.loading = true
      this.get(url, response => {
        this.loading = false
        if (this.offset > 0) {
          this.loadedData = this.loadedData.concat(response.data)
        } else {
          this.loadedData = response.data
        }
      })
    },

    prev: function () {
      this.index = this.wrap(this.index - 1, 12)
      this.month = this.months[this.index]
      this.year = this.index === 11 ? this.year - 1 : this.year
      this.getData()
    },

    next: function () {
      this.index = this.wrap(this.index + 1, 12)
      this.month = this.months[this.index]
      this.year = this.index === 0 ? this.year + 1 : this.year
      this.getData()
    },

    wrap: function (x, m) {
      return (x % m + m) % m
    },

    hero: function (post) {
      const name = post.content.main_image
      const files = post.files
      if (name.length > 0) {
        return files.find(item => item.filename === name)
      } else {
        return false
      }
    },

    heroImage (post) {
      const hero = this.hero(post)
      console.log(hero.url)
      return hero.url
    },

    heroCaption: function (post) {
      let hero = this.hero(post)
      return hero.meta.caption
    }
  },

  computed: {
    posts: function () {
      return this.loadedData.posts
    },

    maxReached: function () {
      return this.month === this.maxMonth && this.year === this.maxYear
    }
  }
}
</script>

<style lang="sass">
  @import '../styles/_mixins'
  @import '../styles/_variables'
  .content
    padding-top: 14rem
    @include respond-to(xs)
      padding-top: 0rem
    .titles
      width: 80%
      margin-top: 14rem
      @include respond-to(xs)
        margin-top: 0rem
      h1
        padding-top: 4rem
        @include respond-to(xs)
          padding-top: 2rem
      ul
        margin-top: 4rem
        @include respond-to(xs)
          margin-top: 0rem
      h3
        margin-bottom: 0.5rem
        cursor: pointer
        &.date
          color: $learn
          cursor: crosshair
      .category
        padding-bottom: 2rem
      .desc
        padding-bottom: 2rem
        color: $learn
    .category
      color: $learn
    .screen-small
      .captions
        h2
          &:nth-of-type(1)
            padding: 0 0 10rem 3.3rem
            @include respond-to(xs)
              padding: 0 0 7.7rem 1rem
</style>



// WEBPACK FOOTER //
// Blog.vue?2c179068